// @flow

import React from 'react';
import styled from 'styled-components';
import type { Theme } from '@types/index';

const AnchorIcon = styled<any, Theme>('a')`
  border: 1px solid ${props => props.theme.news.linkColor};
  border-radius: 50%;
  height: 1.125rem;
  width: 1.125rem;
  padding: 0.5rem;
  margin: 0 0.25rem;
  color: ${props => props.theme.news.linkColor};
  text-decoration: none;
`;

const IconStyled = styled<any, Theme>('i')`
  font-size: 1.2rem;
  line-height: 0;
  &:before {
    vertical-align: super;
  }
`;

type Props = {|
  icon: string,
  link: string,
|};

const Icon = ({
  icon,
  link,
}: Props) => (
  <AnchorIcon href={link}>
    <IconStyled className={`icon-${icon}`} />
  </AnchorIcon>
);

export default Icon;
